import React from 'react'

import s from './ModalFullScreen.module.scss'
import styles from 'App.module.scss'

import { CloseIcon } from 'assets/icons/CloseIcon'

import { Spinner } from '../Spinner/Spinner'

interface Props {
  loading?: boolean
  onHide: (e: React.MouseEvent) => void
  children: React.ReactNode | React.ReactNode[]
  style?: React.CSSProperties
  className?: string
  testid?: string
  show?: boolean
  closeDisabled?: boolean
}

export const ModalFullScreen = (props: Props) => {
  const { onHide, children, loading, style, className, testid, show = true, closeDisabled } = props

  return show ? (
    <div
      className={`${s.modalWrapper} ${className}`}
      onClick={(e) => {
        e.stopPropagation()
        e.nativeEvent.stopImmediatePropagation()
      }}
      data-testid={testid}
      style={style}
    >
      <button className={s.closeButton} onClick={onHide} disabled={closeDisabled}>
        <CloseIcon className={s.closeIcon} />
      </button>
      {loading ? (
        <div className={styles.loaderWrapper}>
          <Spinner />
        </div>
      ) : (
        children
      )}
    </div>
  ) : null
}

interface TitleProps {
  children: React.ReactNode | React.ReactNode[]
}

const Title = ({ children }: TitleProps) => {
  return <h1 className={s.title}>{children}</h1>
}

ModalFullScreen.Title = Title
